import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { Dropdown, Menu as DropdownMenu, message } from 'antd';
import {
  getGarageDetailsById,
  updateGarageDetailsById,
  addGarageDetailsById,
  deleteGarageDetail,
} from '../GarageEditPage/actions';
import Menu from '../components/Menu';
import Review from './components/review';
import AddImage from './components/addImage';
import BooleanInput from './components/boolean';
import Text from './components/text';
import SocialMediaLinks from './components/SocialMediaLinks';
import GarageStyles from './components/GarageStyles';
import Accreditation from './components/Accreditation';
import WhyChooseUs from './components/WhyChooseUs';
import GaragePageHeader from '../components/GaragePageHeader';
import Loading from '$app/shared/components/Loading';
import DateInput from './components/dateInput';
import { DivStyled, ContainerStyled, ButtonsContainer, NewButton, SaveButton } from './styled';

let newCount = 0;

const formatFieldName = (fieldName) =>
  fieldName
    .replace(/_/g, ' ') // Replace underscores with space (for snake_case)
    .replace(/-/g, ' ') // Replace dash with space
    .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space between camelCase letters
    .replace(/\b\w/g, (match) => match.toUpperCase()); // Capitalize the first letter of each word

export class GarageDetailsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      details: [],
      detailsSchema: [],
      updatedDetails: {},
      businessName: null,
    };
  }

  componentDidMount() {
    this.getGarage();
  }

  closePageHandler = () => this.props.history.push('/');

  get garageId() {
    return this.props.match.params.garageId;
  }

  getSchema = (details, updatedDetails, detailsSchema) => {
    /**
     * - Filter out those unique items that were already added
     * - opening_times can be updated from Capacity tab as per this story hence filtered out here:
     *   https://fixter.atlassian.net/browse/OPS-1184
     * - one_trust_script_id is not used here
     */
    const currentUpdatedFieldNames = Object.keys(updatedDetails).map((id) => updatedDetails[id].fieldName);
    return detailsSchema
      .filter(
        (ds) =>
          !ds.isUnique ||
          (ds.isUnique &&
            !details.find((d) => d.fieldName === ds.fieldName) &&
            !currentUpdatedFieldNames.includes(ds.fieldName))
      )
      .filter((ds) => ds.fieldName !== 'opening_times' && ds.fieldName !== 'one_trust_script_id');
  };

  getGarage = () =>
    getGarageDetailsById(this.garageId).then((garage) => {
      const { details, detailsSchema, businessName } = garage;

      const sortedDetails = details.sort((a, b) => {
        if (a.createdAt > b.createdAt) return 1;
        if (a.createdAt < b.createdAt) return -1;
        return 0;
      });

      this.setState({
        details: sortedDetails,
        detailsSchema: this.getSchema(details, {}, detailsSchema),
        updatedDetails: {},
        businessName,
      });
    });

  handleInputChange = (cellInfo, event) => {
    const { details, updatedDetails } = this.state;
    const data = [...details];
    const type = data[cellInfo.index].fieldType;
    const { fieldName } = cellInfo.original;

    if (fieldName === 'review') {
      data[cellInfo.index].value[event.target.name] = event.target.value;
    } else if (fieldName === 'social_media_links') {
      data[cellInfo.index].value[event.target.name] = event.target.value;
    } else if (fieldName === 'styles') {
      data[cellInfo.index].value = event.target.value;
    } else if (fieldName === 'why_choose_us' && Array.isArray(data[cellInfo.index].value)) {
      data[cellInfo.index].value = event.target?.value;
    } else if (fieldName === 'main-image' || fieldName === 'image') {
      data[cellInfo.index].value.imageName = event;
    } else if (type === 'boolean') {
      data[cellInfo.index].value = event.target.checked;
    } else if (type === 'date') {
      data[cellInfo.index].value = event;
    } else if (fieldName === 'accreditation') {
      data[cellInfo.index].value = JSON.stringify(event);
    } else {
      data[cellInfo.index].value = event.target.value;
    }

    this.setState({
      details: data,
      updatedDetails: {
        [data[cellInfo.index].id]: data[cellInfo.index],
        ...updatedDetails,
      },
    });
  };

  saveGarageDetails = () => {
    const ids = Object.keys(this.state.updatedDetails);

    const updatedItems = ids
      .filter((id) => id.indexOf('new') === -1)
      .map((id) => this.state.updatedDetails[id])
      .map((item) => updateGarageDetailsById(this.garageId, item));

    const newItems = ids
      .filter((id) => id.indexOf('new') > -1)
      .map((id) => {
        const item = { ...this.state.updatedDetails[id] };
        delete item.id;
        return item;
      })
      .map((item) => addGarageDetailsById(this.garageId, item));

    Promise.all([...updatedItems, ...newItems]).then(() => this.getGarage());
  };

  addNewDetail = (item) => {
    const { details, updatedDetails, detailsSchema } = this.state;
    newCount += 1;
    
    let initialValue = item.fieldType === 'json' ? {} : undefined;
    
    // Set default values for styles field
    if (item.fieldName === 'styles') {
      initialValue = {
        background_color: '#313437',
        primary_color: '#ffffff',
        primary_color_accent: '#ffffff',
        primary_color_neutral: '#ffffff',
        links_color: '#313437',
      };
    }
    
    const newDetail = {
      id: `new${newCount}`,
      fieldName: item.fieldName,
      fieldType: item.fieldType,
      fieldId: item.id,
      value: initialValue,
    };

    const data = [...details, newDetail];
    const currentUpdated = {
      [newDetail.id]: newDetail,
      ...updatedDetails,
    };

    this.setState({
      details: data,
      updatedDetails: currentUpdated,
      detailsSchema: this.getSchema(data, updatedDetails, detailsSchema),
    });
  };

  menu = () => {
    // Remove duplicates by fieldName and sort
    const uniqueSchema = Array.from(
      new Map(this.state.detailsSchema.map((item) => [item.fieldName, item])).values()
    ).sort((a, b) => a.fieldName.localeCompare(b.fieldName));

    return (
      <DropdownMenu>
        {uniqueSchema.map((item) => (
          <DropdownMenu.Item key={item.id}>
            <div onClick={() => this.addNewDetail(item)}>{item.fieldName}</div>
          </DropdownMenu.Item>
        ))}
      </DropdownMenu>
    );
  };

  renderEditable = (cellInfo) => {
    const cellValue = this.state.details[cellInfo.index].value;
    const type = this.state.details[cellInfo.index].fieldType;

    const handleInputChange = this.handleInputChange.bind(null, cellInfo);

    if (cellInfo.original.fieldName === 'review') {
      return <Review cellValue={cellValue || {}} onFocusOut={handleInputChange} />;
    }

    if (cellInfo.original.fieldName === 'social_media_links') {
      return <SocialMediaLinks cellValue={cellValue || {}} onFocusOut={handleInputChange} />;
    }

    if (cellInfo.original.fieldName === 'styles') {
      return <GarageStyles cellValue={cellValue || {}} onFocusOut={handleInputChange} />;
    }

    if (cellInfo.original.fieldName === 'accreditation') {
      return <Accreditation cellValue={cellValue} onFocusOut={handleInputChange} />;
    }

    if (cellInfo.original.fieldName === 'why_choose_us') {
      return <WhyChooseUs cellValue={cellValue} onFocusOut={handleInputChange} />;
    }

    if (cellInfo.original.fieldName === 'main-image' || cellInfo.original.fieldName === 'image') {
      return (
        <AddImage
          garageId={this.garageId}
          cellValue={cellValue || {}}
          handleInputChange={handleInputChange}
        />
      );
    }

    if (type === 'boolean') {
      return <BooleanInput cellValue={cellValue} handleInputChange={handleInputChange} />;
    }

    if (type === 'date') {
      return <DateInput cellValue={cellValue} handleInputChange={handleInputChange} />;
    }

    return <Text cellValue={cellValue} onFocusOut={handleInputChange} />;
  };

  deleteCell(cellInfo) {
    const details = [...this.state.details];
    const detail = details[cellInfo.index];

    deleteGarageDetail(this.garageId, detail)
      .then(() => message.info('garage detail deleted', 1))
      .finally(() => this.getGarage());
  }

  render() {
    const { history } = this.props;
    const { garageId } = this;
    const { businessName, details } = this.state;

    if (!garageId) return <Loading />;

    const columns = [
      {
        Header: 'Id',
        accessor: 'id',
      },
      {
        Header: 'Name',
        accessor: 'fieldName',
        Cell: ({ value }) => <span>{formatFieldName(value)}</span>,
      },
      {
        Header: 'Value',
        accessor: 'value',
        Cell: (cellInfo) => this.renderEditable(cellInfo),
      },
      {
        Header: 'Change status',
        accessor: 'status',
        Cell: (row) => (
          <span>
            <button type="button" className="btn btn-danger" onClick={() => this.deleteCell(row)}>
              <span className="panel-title"> Delete </span>
            </button>
          </span>
        ),
      },
    ];

    return (
      <ContainerStyled>
        <GaragePageHeader history={history} name={businessName} />

        <Menu selectedItem="details" garageId={garageId} history={history} />

        <DivStyled>
          <ReactTable data={details} columns={columns} showPagination={false} pageSize={details?.length} />

          <ButtonsContainer>
            <Dropdown overlay={this.menu()} trigger={['click']}>
              <NewButton> New </NewButton>
            </Dropdown>

            <SaveButton onClick={this.saveGarageDetails}> Save </SaveButton>
          </ButtonsContainer>
        </DivStyled>
      </ContainerStyled>
    );
  }
}

export default withRouter(GarageDetailsPage);
